












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/personne/edit/EditPortail.vue'
import { getDefaultAloPersonne, AloPersonne } from '@/models/alo/AloPersonne'
import cloneDeep from 'clone-deep'
import { getDefaultAloUser } from '@/models/alo/AloUser'
 
@Component({
  name: 'ReadConfig',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    personne:{
      type:Object,
      default:getDefaultAloPersonne
    }
    
  }
})
export default class ReadConfig extends Vue {
  
  private personne!:AloPersonne
  private loading!:boolean      
  private saving = false
  

  edit() { 
    (this.$refs.edit as Edit).edit(this.personne)
  }

  private get enable() {
    return (!!this.personne.usr &&  !this.personne.usr.usrIsDisabled)
  }    

  private set enable(newValue) {    
    const modifiedPersonne = cloneDeep(this.personne)    
    if(newValue) {       
      if(!modifiedPersonne.usr) modifiedPersonne.usr = getDefaultAloUser()
      modifiedPersonne.usr.usrIsDisabled = false
    }
    else {
      modifiedPersonne.usr.usrIsDisabled = true      
    }
    this.saving = true
    this.$store.myActions.ADM_PERSONNE_SAVE_REQUEST(modifiedPersonne).finally(()=>{
      this.saving = false
    })  
  }  

}
